import { AppContent } from './AppContent';
import bosContent from './bos';
import lloydsContent from './lloyds';
import { Brand } from '../containers/brandProvider';

interface AppContentResolverContext {
  brand: Brand;
}

export default ({ brand }: AppContentResolverContext): AppContent => {
  switch (brand) {
    case 'lloyds':
      return lloydsContent;

    case 'bos':
      return bosContent;

    default:
      return lloydsContent;
  }
};
